module.exports = __webpack_public_path__ + "static/media/amedicarx_ios.2087ce47.png";